import { acceptHMRUpdate, defineStore } from "pinia";
import { isEmpty } from "@/helpers/utility/Text";
import type { QuestionItem } from "./QuestionItem";

const questionState: QuestionItem = {
  id: 0,
  type: "question",
  uid: `question_0`,
  text: "",
  x: 375,
  y: 250,
  width: 250, // not used in this version
  height: 200, // not used in this version
  hidden: true
};

export const useQuestionStore = defineStore("question", {
  state: () => ({ ...questionState }),

  actions: {
    hide() {
      this.hidden = true;
    },
    show() {
      this.hidden = false;
    },
    set(options: Partial<QuestionItem>) {
      this.$patch((state) => {
        if (isEmpty(state.text) && !isEmpty(options.text)) {
          options.hidden = false;
        }
        Object.assign(state, options);
      });
    }
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    acceptHMRUpdate(useQuestionStore as any, import.meta.hot)
  );
}
